import { useFlags } from "flagsmith/react";

/** Flag do corte do gráfico legado (extração de JSON do texto) para o `chart` block (ST-2). */
export const STRUCTURED_BLOCKS_CHART_FLAG = "structured-blocks-chart";

/**
 * Decide se o front deve PREFERIR o `chart` block estruturado ao gráfico legado extraído do
 * texto (`extractAgentPayload` → `visualization`). Enquanto o backend emite os dois em
 * paralelo (fase de migração), esta flag evita gráfico duplicado e permite o corte gradual.
 *
 * Fonte: flag do Flagsmith, com override local via
 * `localStorage.setItem("structured-blocks-chart", "true" | "false")` para QA/e2e.
 * Default (flag ausente): `false` — comportamento legado preservado (sem regressão).
 */
export function useStructuredBlocksChart(): boolean {
  const flags = useFlags([STRUCTURED_BLOCKS_CHART_FLAG]);

  const override =
    typeof window !== "undefined"
      ? window.localStorage.getItem(STRUCTURED_BLOCKS_CHART_FLAG)
      : null;

  if (override === "true") return true;
  if (override === "false") return false;

  return true;
}
